module.exports = __webpack_public_path__ + "static/img/zngk_p1.effa98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/zngk_p1.png
// module id = GMp8
// module chunks = 19